import './callout.css';

import { CheckIcon, ExclamationTriangleIcon, InformationCircleIcon, XCircleIcon, XMarkIcon } from '@heroicons/react/24/outline';
import { cva, VariantProps } from 'class-variance-authority';
import * as React from 'react';
import { useState } from 'react';

import { Icon } from '@/components/core/Icon';

const calloutVariants = cva('callout', {
    variants: {
        variant: {
            info: 'callout-info',
            destructive: 'callout-destructive',
            success: 'callout-success',
            warning: 'callout-warning'
        },
    },
    defaultVariants: {
        variant: 'info',
    },
});

const CalloutIconsMap = {
    info: {
        icon: InformationCircleIcon,
        iconVariant: 'secondary'
    },
    destructive: {
        icon: XCircleIcon,
        iconVariant: 'destructive'
    },
    success: {
        icon: CheckIcon,
        iconVariant: 'success'
    },
    warning: {
        icon: ExclamationTriangleIcon,
        iconVariant: 'warning'
    }
};

interface CalloutProps
    extends React.HTMLAttributes<HTMLElement>,
        VariantProps<typeof calloutVariants> {
            canBeClosed?: boolean;
        }

const Callout = ({ canBeClosed = true, children, className, variant = 'info' }: CalloutProps) => {

    const [hidden, setHidden] = useState(false);

    return (
        !hidden &&
            <div className={`tw-flex tw-flex-row tw-items-center ${calloutVariants({ variant, className })}`}>
                {/* First column */}
                <div className="ttw-w-14 tw-p-6 tw-flex tw-items-center tw-justify-center">
                    <Icon
                        //@ts-ignore
                        icon={CalloutIconsMap[variant].icon}
                        //@ts-ignore
                        variant={CalloutIconsMap[variant].iconVariant}
                        colorScheme="darker"
                        size="xl"
                    />
                </div>

                {/* Second column */}
                <div className="tw-flex-1 tw-p-6">{children}</div>

                {/* Third column */}
                { canBeClosed &&
                    <div className="tw-p-6 tw-flex tw-items-center tw-justify-center">
                        <span className="tw-cursor-pointer tw-opacity-50" onClick={() => setHidden(true)}>
                            <Icon
                                //@ts-ignore
                                variant={CalloutIconsMap[variant].iconVariant}
                                colorScheme="darker"
                                icon={XMarkIcon}
                                size="lg"
                            />
                        </span>
                    </div>
                }
            </div>
    );
};

export { Callout };
